import $ from 'jquery';

const TextCut = function () {
  let $setElm = $('.l-footer .channel__link p');
  let cutFigure = '36';
  let afterTxt = '...';

  $setElm.each(function(){
    const textLength = $(this).text().length;
    const textTrim = $(this).text().substr(0,(cutFigure))

    if(cutFigure < textLength) {
      $(this).html(textTrim + afterTxt).css({visibility:'visible'});
    } else if(cutFigure >= textLength) {
      $(this).css({visibility:'visible'});
    }
  });
};

export default TextCut;


// WEBPACK FOOTER //
// ./src/recruit/js/textcut.js